module.exports = __webpack_public_path__ + "assets/img/5_1365_big.7baa5942.jpg";